import { useEffect } from 'react';
import { Box } from '@zillow/constellation-10';
import PaymentsUpsell from '../Rent/PaymentsUpsell';
import { emitRentReportingUpsellView } from '../../analytics/events';

const EmptyRent = () => {
  useEffect(() => {
    emitRentReportingUpsellView();
  }, []);

  return (
    <Box
      css={{
        display: 'flex',
        flexDirection: 'column',
        border: '{borderWidths.default} solid {colors.gray.300}',
        // oxlint-disable-next-line constellation/prefer-semantic-tokens -- pre-existing base-token usage; was warn-only under ESLint's pandaLint
        borderRadius: '{radii.300}',
      }}
      data-testid="RentReporting"
    >
      <PaymentsUpsell />
    </Box>
  );
};

export default EmptyRent;
